export const DROPBOX_FOLDER_SYNC_QUERY_KEYS = {
  COMPANY_MEASUREMENT_DATE_BY_ATTIO_VALUATION_ID: 'company-measurement-date-by-attio-valuation-id',
} as const;

export const DROPBOX_FOLDER_SYNC_MESSAGES = {
  SEARCH_COMPANY_FOLDER_ERROR: 'Failed to search company folders in Dropbox.',
  LIST_VALUATION_FOLDER_ERROR: 'Failed to list valuation folders in Dropbox.',
  SET_COMPANY_FOLDER_FIRST: 'Set and sync Company Folder before listing valuation folders.',
  SET_COMPANY_FOLDER_BEFORE_VALUATION: 'Set and sync Company Folder before creating valuation folders.',
  SET_COMPANY_FOLDER_BEFORE_VALUATION_SYNC: 'Set and sync Company Folder before syncing valuation folder.',
  ENTER_COMPANY_FOLDER_NAME: 'Please enter a company folder name first.',
  ENTER_COMPANY_FOLDER_NAME_SYNC: 'Please enter a company folder name before syncing.',
  ENTER_VALUATION_FOLDER_NAME: 'Please enter a valuation folder name first.',
  ENTER_VALUATION_FOLDER_NAME_SYNC: 'Please enter a valuation folder name before syncing.',
  COMPANY_FOLDER_EXISTS: 'Company folder already exists in Dropbox.',
  COMPANY_FOLDER_CREATED: 'Company folder created in Dropbox.',
  COMPANY_FOLDER_CREATE_ERROR: 'Failed to create company folder in Dropbox.',
  VALUATION_FOLDER_EXISTS: 'Valuation folder already exists in Dropbox.',
  VALUATION_FOLDER_CREATED: 'Valuation folder created in Dropbox.',
  VALUATION_FOLDER_CREATE_ERROR: 'Failed to create valuation folder in Dropbox.',
  COMPANY_ID_NOT_AVAILABLE: 'Company ID not available. Please ensure the company is properly linked.',
  FOLDER_NOT_IN_DROPBOX: 'Folder does not exist in Dropbox yet. Search or create it before syncing.',
  COMPANY_FOLDER_UPDATED: 'Company folder updated successfully',
  COMPANY_FOLDER_UPDATE_ERROR: 'Failed to update company folder. Please try again.',
  VALUATION_FOLDER_UPDATED: 'Valuation folder updated successfully',
  VALUATION_FOLDER_UPDATE_ERROR: 'Failed to update valuation folder. Please try again.',
  LOADING_MEASUREMENT_DATE: 'Loading measurement date information, please wait...',
  MEASUREMENT_DATE_NOT_LINKED: 'Unable to find measurement date for this valuation. Please ensure the valuation is linked to a measurement date.',
  MEASUREMENT_DATE_NOT_AVAILABLE: 'Measurement date ID not available. Please try refreshing the page.',
} as const;
